import { MultidayType } from 'features/common/types';
import { FlexContainer } from 'features/common/components/FlexContainer';
import { TicketRow } from '../TicketRow';

export const MultidayRow = ({ ticketTypes, day }: MultidayType, isPunchup?: boolean) => (
	<FlexContainer flexDirection="column" key={day.id}>
		{ticketTypes.map((tt) => TicketRow(tt, isPunchup))}
	</FlexContainer>
);
